import { COLOR } from '@src/styles/color';
import styled from 'styled-components';

export const StyledBlockAudioPopover = styled.div`
  position: absolute;
  right: calc(100% + 4px);
  top: 50%;
  transform: translateY(-50%);
  z-index: 10;
  background-color: ${COLOR.white};
  background-image: linear-gradient(
    ${COLOR.secondary[40]},
    ${COLOR.secondary[40]}
  );
  border-radius: 480px;
  height: 40px;
  width: 240px;
  padding: 0 12px;
  display: flex;
  align-items: center;
  gap: 8px;

  .popover-time {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 72px;
    flex-shrink: 0;
    font-size: 12px;
    font-family: 'SF Pro Text', sans-serif;
    font-weight: 400;
    line-height: 16px;
    letter-spacing: -0.4px;
    color: ${COLOR.darkGray};
  }

  .popover-slider-wrapper {
    height: 16px;
    flex: 1;
    min-width: 0;
    display: flex;
    align-items: center;
  }

  .popover-slider {
    width: 100%;
    color: ${COLOR.indigo.default};
    padding: 0;
    margin: 0;

    .MuiSlider-thumb {
      width: 12px;
      height: 12px;
      box-shadow: 0 0 0 3px ${COLOR.white}, 0 1px 4px ${COLOR.black[16]};

      &:hover,
      &.Mui-focusVisible,
      &.Mui-active {
        box-shadow: 0 0 0 3px ${COLOR.white}, 0 1px 4px ${COLOR.black[16]};
      }
    }

    .MuiSlider-track {
      height: 6px;
      border-radius: 480px;
      border: none;
    }

    .MuiSlider-rail {
      height: 6px;
      border-radius: 480px;
      opacity: 1;
      background-color: ${COLOR.secondary[80]};
    }
  }
`;
